module.exports = __webpack_public_path__ + "img/vec.2032f9c2.svg";